import React, { useEffect, useImperativeHandle, useRef } from 'react'
import ClientModule from '../../modules/client/Module'
import DevLog from '../../modules/devlog/Module'

import { addOnTryAgainToAction } from '../error/onTryAgain'
import { ActionType, IActionComponentAPI, IActionComponentProps, IActionSubmitResponse } from '../types'

import useSession from '../../session/useSession'
import useMountedRef from '@aytm/lib/hooks/useMountedRef'

import LoaderView from '../loader/View'

import style from '../loader/style.module.scss'

const LoadAction = React.memo(
  React.forwardRef<IActionComponentAPI, IActionComponentProps>(({ action }, ref) => {
    const session = useSession()
    useEffect(() => {
      session.setWidgetWidth(null)
      session.enableNavigation(false)
      session.progress.updateFromAction(action)
      session.currentTarget = null
    }, [session, action])

    useImperativeHandle<IActionComponentAPI, IActionComponentAPI>(ref, () => {
      return {
        tryNext() {
          return false
        },
        tryPrev() {
          return false
        },
        showValidation() {
          //
        },
        get submitResponse() {
          const submitResponse: IActionSubmitResponse[] = []
          return submitResponse
        },
        get currentQuestionModel(): null {
          return null
        }
      }
    }, [])

    const actionLoadingRef = useRef(false)
    const mountedRef = useMountedRef()
    useEffect(() => {
      if (!actionLoadingRef.current) {
        actionLoadingRef.current = true
        // isRetry: "try again" fires from the error view after this component has
        // unmounted, so the mountedRef guard must not swallow the retried dispatch
        const doLoad = (isRetry = false) => {
          ClientModule.loadAction(action).then(
            loadedAction => {
              if (ActionType.ERROR === loadedAction.action) {
                addOnTryAgainToAction(loadedAction, () => doLoad(true))
              }
              if (isRetry || mountedRef.current) {
                session.doAction(loadedAction)
              }
            },
            error => {
              DevLog.error(error, 'SW[LoadAction]')
            }
          )
        }
        doLoad()
      }
    }, [action, session, mountedRef])

    return (
      <div className={style.action}>
        <LoaderView />
      </div>
    )
  }),
  (prevProps, nextProps) => prevProps.action === nextProps.action
)

LoadAction.displayName = 'LoadAction'

export default LoadAction
